import React from 'react';
import ReactDOM from 'react-dom';
import 'core-js/fn/array/includes';
import 'core-js/fn/array/keys';
import 'core-js/fn/object/values';
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk';
import {responsiveStoreEnhancer} from 'redux-responsive'
import reducers from './store/reducers/index'
import App from './App';
import injectTapEventPlugin from 'react-tap-event-plugin';
import numeral from 'numeral';
import './index.css';


numeral.register('locale', 'se', {
    delimiters: {
        thousands: ' ',
        decimal: ','
    }
});

numeral.locale('se');

injectTapEventPlugin();

const store = createStore(reducers, compose(applyMiddleware(thunk), responsiveStoreEnhancer));

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js